import { useState } from "react";
import CustomMessage from "./CustomMessage";
import ErrorMessage from "./ErrorMessage";
import PageHeader from "./PageHeader";
import { PaymentMethodList, type ErrorMessageValue } from "./PaymentMethodList";
import PaymentSummary from "./PaymentSummary";

export default function PageDisplay() {
  const [errorMessage, setErrorMessage] = useState<ErrorMessageValue>(null);

  return (
    <>
      <PageHeader />
      <main className="container pt-s gap-s">
        {errorMessage && <ErrorMessage error={errorMessage} />}
        <PaymentSummary />
        <CustomMessage />
        <PaymentMethodList onErrorChange={setErrorMessage} />
      </main>
    </>
  );
}
